<script setup>
import RentbirdLogo from '@js/Components/Logos/RentbirdLogo/RentbirdLogo.vue'
import RentbirdRelocationLogo from '@js/Components/Logos/RentbirdRelocationLogo/RentbirdRelocationLogo.vue'
import RentbirdPlusLogo from '@js/Components/Logos/RentbirdPlusLogo/RentbirdPlusLogo.vue'
import TrustpilotRating from '@js/Components/Trustpilot/TrustpilotRating.vue'
import TrustpilotSmall from '@js/Components/Trustpilot/TrustpilotSmall.vue'
import { useIsMobile } from '@js/App/Utils/BrowserDetection'
import Container from '@js/Components/Container/Container.vue'

const { isMobile } = useIsMobile()

const props = defineProps({
  logo: {
    type: String,
    default: 'rentbird'
  }
})

</script>
<template>
  <div class="bg-purple-700">
    <Container>
      <div class="py-6 lg:py-8 flex justify-between items-center">
        <RentbirdLogo
          v-if="props.logo === 'rentbird'"
          :size="isMobile ? 'xs' : 'sm'"
          :dark="true"
        />
        <RentbirdRelocationLogo
          v-if="props.logo === 'rentbird-relocation'"
          :size="isMobile ? 'xs' : 'sm'"
        />
        <RentbirdPlusLogo
          v-if="props.logo === 'rentbird-plus'"
          :size="isMobile ? 'xs' : 'sm'"
        />
        <TrustpilotRating v-if="isMobile" :black="false" />
        <TrustpilotSmall
          v-else
          :black="false"
          class="relative top-[4px]"
        />
      </div>
    </Container>
  </div>
</template>
